module.exports = __webpack_public_path__ + "img/east-timor.39431048.svg";